// Auto-generated per-query builders for LogicalPart
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { LogicalPartReadAPI, LogicalPartWriteAPI, LogicalPartReadAPISchema, LogicalPartWriteAPISchema } from '../types/logicalpart';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, ContainsAction, ContainsLogicalPart, HasAttribute, HasAttributeValue, HasDerivedValue, HasInterfacePort, HasRequirement, HasStakeholderNeed, LPBindsBehavioralPort, LPHasBehavioralPort, Mentions, OwnedByUser, PartBindsInterfacePort, ProjectHasRootPart, RFLPAllocation, RFLPPerforms, RealizedByProject, RequirementPart, Satisfies } from '../../relationships/relationship';

import { Project } from './project';
import { Action } from './action';
import { StakeholderNeed } from './stakeholderneed';
import { Part } from './part';
import { Requirement } from './requirement';
import { PhysicsPort } from './physicsport';
import { InterfacePort } from './interfaceport';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';
import { User } from '../../base/api/user';





// Builder chain for query: rflp-logical-part-by-id

export interface RflpLogicalPartByIdBuilder_0 {
  get(id: string): RflpLogicalPartByIdBuilder_1;
  filter(conditions: { id: string }): RflpLogicalPartByIdBuilder_1;
}

export interface RflpLogicalPartByIdBuilder_1 {
  all(): Promise<LogicalPart[]>;
  first(): Promise<LogicalPart | null>;
  get(): Promise<LogicalPart[]>;
  execute(): Promise<LogicalPart[]>;
}


// Union of all query entry points
export type LogicalPartQueryBuilder = RflpLogicalPartByIdBuilder_0;

// Available query names for .setQuery()
export type LogicalPartQueryNames = "rflp-logical-part-by-id";

// Type narrowing for .setQuery()
export type LogicalPartBuilderForQuery<Q extends LogicalPartQueryNames> =
  Q extends "rflp-logical-part-by-id" ? RflpLogicalPartByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type LogicalPartInstanceQueryResult<Q extends LogicalPartQueryNames> =
  Q extends "rflp-logical-part-by-id" ? RflpLogicalPartByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-logical-part-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends LogicalPartQueryNames>(queryName: Q): LogicalPartBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface LogicalPart extends Partial<LogicalPartReadAPI> {}
export class LogicalPart extends NeoNodeBase<LogicalPartReadAPI, LogicalPartWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "LogicalPart";
  static readonly readSchema = LogicalPartReadAPISchema;
  static readonly writeSchema = LogicalPartWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    responsible_user: { target: "User", cardinality: "one", isParent: false, relClass: "OwnedByUser", direction: "out" },
    parent: { target: "LogicalPart", cardinality: "one", isParent: true, relClass: "ContainsLogicalPart", direction: "in" },
    children: { target: "LogicalPart", cardinality: "many", isParent: false, relClass: "ContainsLogicalPart", direction: "out" },
    root_of: { target: "Project", cardinality: "one", isParent: true, relClass: "ProjectHasRootPart", direction: "in" },
    realized_by_project: { target: "Project", cardinality: "one", isParent: false, relClass: "RealizedByProject", direction: "out" },
    actions: { target: "Action", cardinality: "many", isParent: false, relClass: "ContainsAction", direction: "out" },
    stakeholder_needs: { target: "StakeholderNeed", cardinality: "many", isParent: false, relClass: "HasStakeholderNeed", direction: "out" },
    performs: { target: "Action", cardinality: "many", isParent: false, relClass: "RFLPPerforms", direction: "out" },
    allocated_to: { target: "Part", cardinality: "many", isParent: false, relClass: "RFLPAllocation", direction: "out" },
    requirements: { target: "Requirement", cardinality: "many", isParent: false, relClass: "HasRequirement", direction: "out" },
    anchored_requirements: { target: "Requirement", cardinality: "many", isParent: false, relClass: "RequirementPart", direction: "in" },
    satisfies: { target: "Requirement", cardinality: "many", isParent: false, relClass: "Satisfies", direction: "out" },
    behavioral_ports: { target: "PhysicsPort", cardinality: "many", isParent: false, relClass: "LPHasBehavioralPort", direction: "out" },
    interface_ports: { target: "InterfacePort", cardinality: "many", isParent: false, relClass: "HasInterfacePort", direction: "out" },
    bound_behavioral_ports: { target: "PhysicsPort", cardinality: "many", isParent: false, relClass: "LPBindsBehavioralPort", direction: "out" },
    bound_interface_ports: { target: "InterfacePort", cardinality: "many", isParent: false, relClass: "PartBindsInterfacePort", direction: "out" },
  };

  protected get modelName(): string {
    return 'LogicalPart';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return LogicalPart.label;
  }


  constructor(data: Partial<LogicalPartWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: LogicalPartReadAPI, loadContext?: Record<string, any>): LogicalPart {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { parent, children, root_of, realized_by_project, actions, stakeholder_needs, performs, allocated_to, requirements, anchored_requirements, satisfies, behavioral_ports, interface_ports, bound_behavioral_ports, bound_interface_ports, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, responsible_user, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = LogicalPartReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, parent: parent, children: children, root_of: root_of, realized_by_project: realized_by_project, actions: actions, stakeholder_needs: stakeholder_needs, performs: performs, allocated_to: allocated_to, requirements: requirements, anchored_requirements: anchored_requirements, satisfies: satisfies, behavioral_ports: behavioral_ports, interface_ports: interface_ports, bound_behavioral_ports: bound_behavioral_ports, bound_interface_ports: bound_interface_ports, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions, responsible_user: responsible_user };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return LogicalPart.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'parent', 'LogicalPart', ModelRegistry);
    loadManyRelationship(processed, 'children', 'LogicalPart', ModelRegistry);
    loadOneRelationship(processed, 'root_of', 'Project', ModelRegistry);
    loadOneRelationship(processed, 'realized_by_project', 'Project', ModelRegistry);
    loadManyRelationship(processed, 'actions', 'Action', ModelRegistry);
    loadManyRelationship(processed, 'stakeholder_needs', 'StakeholderNeed', ModelRegistry);
    loadManyRelationship(processed, 'performs', 'Action', ModelRegistry);
    loadManyRelationship(processed, 'allocated_to', 'Part', ModelRegistry);
    loadManyRelationship(processed, 'requirements', 'Requirement', ModelRegistry);
    loadOneRelationship(processed, 'anchored_requirements', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'satisfies', 'Requirement', ModelRegistry);
    loadManyRelationship(processed, 'behavioral_ports', 'PhysicsPort', ModelRegistry);
    loadManyRelationship(processed, 'interface_ports', 'InterfacePort', ModelRegistry);
    loadManyRelationship(processed, 'bound_behavioral_ports', 'PhysicsPort', ModelRegistry);
    loadManyRelationship(processed, 'bound_interface_ports', 'InterfacePort', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    loadOneRelationship(processed, 'responsible_user', 'User', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new LogicalPart(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): LogicalPartQueryBuilder {
    return new QueryBuilderImpl('LogicalPart').filter(conditions) as any;
  }

  static all(): LogicalPartQueryBuilder {
    return new QueryBuilderImpl('LogicalPart') as any;
  }

  static async first(): Promise<LogicalPart | null> {
    const results = await new QueryBuilderImpl('LogicalPart').execute();
    return results[0] || null;
  }


  static setQuery<Q extends LogicalPartQueryNames>(queryName: Q): LogicalPartBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('LogicalPart');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends LogicalPartQueryNames>(queryName: Q): LogicalPartInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = LogicalPart.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const logicalpart = await LogicalPart.get(id).first();
   * await logicalpart.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await logicalpart.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'children' - Python ORM style (cached)
  get children(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('children', () => {
      return new RelationshipManager(this, 'children', 'many', ContainsLogicalPart as typeof Relationship);
    });
  }

  // Relationship manager for 'realized_by_project' - Python ORM style (cached)
  get realized_by_project(): RelationshipManager<this, Project> {
    return this.getOrCreateRelationshipManager('realized_by_project', () => {
      return new RelationshipManager(this, 'realized_by_project', 'one', RealizedByProject as typeof Relationship);
    });
  }

  // Relationship manager for 'actions' - Python ORM style (cached)
  get actions(): RelationshipManager<this, Action> {
    return this.getOrCreateRelationshipManager('actions', () => {
      return new RelationshipManager(this, 'actions', 'many', ContainsAction as typeof Relationship);
    });
  }

  // Relationship manager for 'sub_actions' - Python ORM style (cached)
  get sub_actions(): RelationshipManager<this, Action> {
    return this.getOrCreateRelationshipManager('sub_actions', () => {
      return new RelationshipManager(this, 'sub_actions', 'many', ContainsAction as typeof Relationship);
    });
  }

  // Relationship manager for 'stakeholder_needs' - Python ORM style (cached)
  get stakeholder_needs(): RelationshipManager<this, StakeholderNeed> {
    return this.getOrCreateRelationshipManager('stakeholder_needs', () => {
      return new RelationshipManager(this, 'stakeholder_needs', 'many', HasStakeholderNeed as typeof Relationship);
    });
  }

  // Relationship manager for 'performs' - Python ORM style (cached)
  get performs(): RelationshipManager<this, Action> {
    return this.getOrCreateRelationshipManager('performs', () => {
      return new RelationshipManager(this, 'performs', 'many', RFLPPerforms as typeof Relationship);
    });
  }

  // Relationship manager for 'allocated_to' - Python ORM style (cached)
  get allocated_to(): RelationshipManager<this, Part> {
    return this.getOrCreateRelationshipManager('allocated_to', () => {
      return new RelationshipManager(this, 'allocated_to', 'many', RFLPAllocation as typeof Relationship);
    });
  }

  // Relationship manager for 'requirements' - Python ORM style (cached)
  get requirements(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('requirements', () => {
      return new RelationshipManager(this, 'requirements', 'many', HasRequirement as typeof Relationship);
    });
  }

  // Relationship manager for 'sub_requirements' - Python ORM style (cached)
  get sub_requirements(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('sub_requirements', () => {
      return new RelationshipManager(this, 'sub_requirements', 'many', HasRequirement as typeof Relationship);
    });
  }

  // Relationship manager for 'behavioral_ports' - Python ORM style (cached)
  get behavioral_ports(): RelationshipManager<this, PhysicsPort> {
    return this.getOrCreateRelationshipManager('behavioral_ports', () => {
      return new RelationshipManager(this, 'behavioral_ports', 'many', LPHasBehavioralPort as typeof Relationship);
    });
  }

  // Relationship manager for 'interface_ports' - Python ORM style (cached)
  get interface_ports(): RelationshipManager<this, InterfacePort> {
    return this.getOrCreateRelationshipManager('interface_ports', () => {
      return new RelationshipManager(this, 'interface_ports', 'many', HasInterfacePort as typeof Relationship);
    });
  }

  // Relationship manager for 'bound_behavioral_ports' - Python ORM style (cached)
  get bound_behavioral_ports(): RelationshipManager<this, PhysicsPort> {
    return this.getOrCreateRelationshipManager('bound_behavioral_ports', () => {
      return new RelationshipManager(this, 'bound_behavioral_ports', 'many', LPBindsBehavioralPort as typeof Relationship);
    });
  }

  // Relationship manager for 'bound_interface_ports' - Python ORM style (cached)
  get bound_interface_ports(): RelationshipManager<this, InterfacePort> {
    return this.getOrCreateRelationshipManager('bound_interface_ports', () => {
      return new RelationshipManager(this, 'bound_interface_ports', 'many', PartBindsInterfacePort as typeof Relationship);
    });
  }

  // Relationship manager for 'parent' - Python ORM style (cached)
  get parent(): RelationshipManager<this, LogicalPart> {
    return this.getOrCreateRelationshipManager('parent', () => {
      return new RelationshipManager(this, 'parent', 'many', ContainsLogicalPart as typeof Relationship);
    });
  }

  // Relationship manager for 'satisfies' - Python ORM style (cached)
  get satisfies(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('satisfies', () => {
      return new RelationshipManager(this, 'satisfies', 'many', Satisfies as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

  // Relationship manager for 'responsible_user' - Python ORM style (cached)
  get responsible_user(): RelationshipManager<this, User> {
    return this.getOrCreateRelationshipManager('responsible_user', () => {
      return new RelationshipManager(this, 'responsible_user', 'one', OwnedByUser as typeof Relationship);
    });
  }

  // Relationship manager for 'root_of' - Python ORM style (cached)
  get root_of(): RelationshipManager<this, Project> {
    return this.getOrCreateRelationshipManager('root_of', () => {
      return new RelationshipManager(this, 'root_of', 'one', ProjectHasRootPart as typeof Relationship);
    });
  }

  // Relationship manager for 'anchored_requirements' - Python ORM style (cached)
  get anchored_requirements(): RelationshipManager<this, Requirement> {
    return this.getOrCreateRelationshipManager('anchored_requirements', () => {
      return new RelationshipManager(this, 'anchored_requirements', 'many', RequirementPart as typeof Relationship);
    });
  }

}
